import {action} from 'mobx';

import {EXPIRES_ERROR, EXPIRES_PENDING, EXPIRE_TIME} from '../../../constants/storeConstants';
import {STATE_FULFILLED, STATE_PENDING, STATE_REJECTED} from '../../../constants/asyncConstants';
import serverApi from '../../../utils/serverApi';
import ApiBaseStore from '../common/apiBaseStore';

/**
 * ApiUserGetAuth0EmailStore
 */
class ApiUserGetAuth0EmailStore extends ApiBaseStore {
  /**
   * Fetches email of auth0 user from hub
   * @param {authId} authId
   */
  @action makeRequest(authId) {
    this.state = STATE_PENDING;
    this[EXPIRE_TIME] = Date.now() + EXPIRES_PENDING;

    serverApi.getEmailFromAuth0(authId)
      .then(action('userGetAuth0EmailSuccess', (res) => {
        this.state = STATE_FULFILLED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_ERROR;
        this.data = res.email;
        this.error = null;
      })).catch(action('userGetAuth0EmailError', (error) => {
        this.state = STATE_REJECTED;
        this[EXPIRE_TIME] = Date.now() + EXPIRES_ERROR;
        this.data = null;
        this.error = error;
      }));
  }
}

export default new ApiUserGetAuth0EmailStore();
